import { ReactComponent as SuccessIconSVG } from '@/assets/icons/SuccessIcon.svg';
import { SVGProps } from 'react';

const SuccessIcon = (props: SVGProps<SVGSVGElement>) => <SuccessIconSVG {...props} />;

export default SuccessIcon;
